const navigation = [
  {
    name: 'Services',
    links: [
      { name: 'Web Design', href: 'web-design' },
      { name: 'VIP Support', href: 'vip-support' },
      { name: 'Email Marketing', href: 'email-marketing' },
      { name: 'Paid Search', href: 'paid-search' },
      { name: 'Social Media Marketing', href: 'social-media-marketing' },
      { name: 'SEO', href: 'seo' },
    ],
  },
  {
    name: 'About Us',
    href: 'about',
  },
  {
    name: 'Case Studies',
    href: 'case-studies',
  },
  {
    name: 'Tools',
    links: [
      {
        name: 'Growth Calculator',
        href: 'grow',
      },
    ],
  },
  {
    name: 'Resources',
    href: 'resources',
  },
]

export default navigation
